import { render, staticRenderFns } from "./TheSIPEndpoint.vue?vue&type=template&id=689df200&"
import script from "./TheSIPEndpoint.vue?vue&type=script&lang=js&"
export * from "./TheSIPEndpoint.vue?vue&type=script&lang=js&"
import style0 from "./TheSIPEndpoint.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports